<template>
  <BaseButton ghost small @click="open">
    <span class="truncate"> Remove </span>
  </BaseButton>
</template>

<script>
import { productProjectsClient } from '@/api/clients/admin';

export default {
  props: {
    productId: {
      type: String,
      required: true,
    },
    project: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showForm: false,
    };
  },
  methods: {
    async open() {
      this.$modal.show({
        component: () => import('Components/ProductProjects/ProjectRemoveModal.vue'),
        props: {
          action: async (projectId) => {
            try {
              await productProjectsClient.destroy(this.productId, projectId);

              return Promise.resolve();
            } catch (error) {
              return Promise.reject(error);
            }
          },
          project: this.project,
        },
        on: {
          'project-removed': (project) => {
            this.$emit('project-removed', project);
          },
        },
        hideEvent: 'hide',
      });
    },
  },
};
</script>
